import { render, staticRenderFns } from "./AnonymousWaitingOrder.vue?vue&type=template&id=3f188156&scoped=true"
import script from "./AnonymousWaitingOrder.vue?vue&type=script&lang=js"
export * from "./AnonymousWaitingOrder.vue?vue&type=script&lang=js"
import style0 from "./AnonymousWaitingOrder.vue?vue&type=style&index=0&id=3f188156&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f188156",
  null
  
)

export default component.exports